/**
 * The CSS stack for a flow document's font category.
 *
 * The renderer draws with metric-compatible stand-ins (Arimo≈Arial, Tinos≈Times New Roman,
 * Cousine≈Courier New), so the editor asks for the faces those stand in FOR: the author is
 * checking the document against Word, not against the PDF's substitute. Arial is named before
 * Helvetica because that is what a Word document on Windows actually resolves to.
 */
export const FONT_STACK_BY_CATEGORY = {
	'sans-serif': 'Arial, Arimo, Helvetica, sans-serif',
	serif: "'Times New Roman', Tinos, Times, serif",
	monospace: "'Courier New', Cousine, monospace",
} as const;

export type FlowFontCategory = keyof typeof FONT_STACK_BY_CATEGORY;

const isCategory = (value: string): value is FlowFontCategory =>
	Object.prototype.hasOwnProperty.call(FONT_STACK_BY_CATEGORY, value);

export const fontStackFor = (category: string | null | undefined): string =>
	category !== null && category !== undefined && isCategory(category)
		? FONT_STACK_BY_CATEGORY[category]
		: FONT_STACK_BY_CATEGORY['sans-serif'];
